import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { PetState } from '~/redux/slices/pet-state'
import { Modal } from '~/utils/analytics/events'
import { logModalView } from '~/utils/analytics'
import { BadgeData } from '~/components/QuestPanel/type'

import { CHAMPIONSHIP_IDS, COLLECTION_LIST, QUIZ_SUBJECT } from '~/types/homebaseQuiz.types'

import { LeagueNames } from '~/Leaderboard/types/leaderboard.types'

import { RootState } from '../store'

interface HomebaseState {
  homebaseIsOpen: boolean
  petState: PetState | undefined
  scrollToBase: boolean
  showcaseBadge?: ShowcaseBadge
  isBadgeReady: boolean
  showingLeagueBadge: LeagueNames | undefined
}

interface ShowcaseBadge {
  subject: QUIZ_SUBJECT | CHAMPIONSHIP_IDS | string
  category?: string
  collection: COLLECTION_LIST
  badgeData?: BadgeData
  leagueBadge?: LeagueNames
}

const initialState: HomebaseState = {
  homebaseIsOpen: false,
  petState: undefined,
  scrollToBase: false,
  showcaseBadge: undefined,
  isBadgeReady: false,
  showingLeagueBadge: undefined,
}

const slice = createSlice({
  name: 'homebase',
  initialState,
  reducers: {
    open: (state) => {
      logModalView(Modal.HOMEBASE)
      return { ...state, homebaseIsOpen: true }
    },

    close: (state) => {
      return { ...state, homebaseIsOpen: false }
    },
    setScrollToBase: (state) => {
      return { ...state, scrollToBase: true }
    },
    resetScrollToBase: (state) => {
      return { ...state, scrollToBase: false }
    },
    setShowcaseBadge: (state, action: PayloadAction<ShowcaseBadge | undefined>) => {
      return {
        ...state,
        showcaseBadge: action.payload,
      }
    },
    setShowingLeagueBadge: (state, action: PayloadAction<LeagueNames | undefined>) => {
      return {
        ...state,
        showingLeagueBadge: action.payload,
      }
    },
    setIsBadgeReady: (state, action: PayloadAction<boolean>) => {
      return {
        ...state,
        isBadgeReady: action.payload,
      }
    },
    setPetState: (state, action: PayloadAction<PetState>) => {
      return {
        ...state,
        petState: action.payload,
      }
    },
    resetPetState: (state, action: PayloadAction<undefined>) => {
      return {
        ...state,
        petState: action.payload,
      }
    },
  },
})

export const selectHomebaseIsOpen = (state: RootState): boolean => state.homebase.homebaseIsOpen
export const selectPetState = (state: RootState): PetState | undefined => state.homebase.petState
export const selectScrollToBase = (state: RootState): boolean => state.homebase.scrollToBase
export const selectShowcaseBadge = (state: RootState): ShowcaseBadge | undefined => state.homebase.showcaseBadge
export const isBadgeReady = (state: RootState): boolean => state.homebase.isBadgeReady
export const selectShowingLeagueBadge = (state: RootState): LeagueNames | undefined => state.homebase.showingLeagueBadge

export const {
  open: openHomebase,
  close: closeHomebase,
  setPetState,
  resetPetState,
  setScrollToBase,
  resetScrollToBase,
  setShowcaseBadge,
  setIsBadgeReady,
  setShowingLeagueBadge,
} = slice.actions

export default slice.reducer
